import { DEFAULT_LAYOUT_EXAM, LayoutExamTypeKeys } from "../../../enums/layoutExamTypes";

export const CREATE_PAGES_TYPES = {
  IS_MEASURING_EXERCISES: "isMeasuringExercises",
  IS_MEASURING_CONTAINER: "isMeasuringContainer",
  CONTAINER_HEIGHT: "containerHeight",
  HEADER_HEIGHT: "headerHeight",
  TOTAL_POINTS_HEIGHT: "totalPointsHeight",
  LAYOUT_TYPE: "layoutType",
};

export const CREATE_PAGES_INITIAL_STATE: CreatePagesState = {
  isMeasuringExercises: true,
  isMeasuringContainer: true,
  containerHeight: 0,
  headerHeight: 0,
  totalPointsHeight: 0,
  layoutType: DEFAULT_LAYOUT_EXAM,
};

export interface CreatePagesState {
  isMeasuringExercises: boolean;
  isMeasuringContainer: boolean;
  containerHeight: number;
  headerHeight: number;
  totalPointsHeight: number;
  layoutType: LayoutExamTypeKeys;
}

export interface Action {
  type: string;
  payload: any;
}

export const createPagesReducer = (state = CREATE_PAGES_INITIAL_STATE, action: Action): CreatePagesState => {
  switch (action.type) {
    case CREATE_PAGES_TYPES.IS_MEASURING_EXERCISES:
      return { ...state, isMeasuringExercises: action.payload };

    case CREATE_PAGES_TYPES.IS_MEASURING_CONTAINER:
      return { ...state, isMeasuringContainer: action.payload };

    case CREATE_PAGES_TYPES.CONTAINER_HEIGHT:
      return { ...state, containerHeight: action.payload };

    case CREATE_PAGES_TYPES.HEADER_HEIGHT:
      return { ...state, headerHeight: action.payload };

    case CREATE_PAGES_TYPES.TOTAL_POINTS_HEIGHT:
      return { ...state, totalPointsHeight: action.payload };

    case CREATE_PAGES_TYPES.LAYOUT_TYPE:
      return { ...state, layoutType: action.payload };

    default:
      return state;
  }
};
